import { AfterViewInit, Component, Input, QueryList, ViewChildren } from "@angular/core";
import { CardNewsComponent } from "@viewer/news/card-news/card-news.component";
import { News } from "@orion2/models/tocitem.models";

@Component({
  standalone: false,
  selector: "o-news-list",
  templateUrl: "./news-list.component.html",
  styleUrls: ["./news-list.component.scss"]
})
export class NewsListComponent implements AfterViewInit {
  @ViewChildren(CardNewsComponent) cards: QueryList<CardNewsComponent>;
  @Input() newsList: News[];
  @Input() emptyLabel: string;
  public allExpanded = false;

  ngAfterViewInit(): void {
    this.onToggleExpansion();
  }

  /**
   * Toggles the expanded state of all news cards.
   * If all cards are currently expanded, it will collapse them all.
   * If any card is collapsed, it will expand all cards.
   */
  public onToggleExpansion(): void {
    this.allExpanded = Array.from(this.cards).every((card: CardNewsComponent) => card.isExpanded);
  }

  /**
   * Expands all news cards in the list.
   * Sets the allExpanded flag to true and calls expand() on each individual card.
   */
  public expandAll(): void {
    this.allExpanded = true;
    this.cards.forEach((card: CardNewsComponent) => {
      card.expand(true);
    });
  }

  /**
   * Collapses all news cards in the list.
   * Sets the allExpanded flag to false and calls reduce() on each individual card.
   */
  public reduceAll(): void {
    this.allExpanded = false;
    this.cards.forEach((card: CardNewsComponent) => {
      card.reduce(true);
    });
  }
}
